import { render, staticRenderFns } from "./WorkspacesList.vue?vue&type=template&id=3284639c&"
import script from "./WorkspacesList.vue?vue&type=script&lang=ts&"
export * from "./WorkspacesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports